import axios from '../services/axios';
import swal from './swal';
import { ehDemonstracao } from './planoConta';

/**
 * Abre o portal de chamados em uma nova aba, com o usuário já autenticado.
 *
 * O backend garante que a conta e o usuário existam no TomTicket e devolve uma
 * URL de acesso de curta duração. Usado nos pontos que antes levavam à tela de
 * suporte: o menu de ajuda dos layouts e o atalho do perfil.
 */

/**
 * Escreve um aviso na aba recém-aberta, enquanto o endereço não chega.
 *
 * A aba é about:blank e pertence a esta origem, então dá para escrever nela.
 */
const avisarNaAba = (aba) => {
  if (!aba) return;

  try {
    aba.document.write(
      '<!doctype html><html lang="pt-BR"><head><meta charset="utf-8">' +
        '<title>Abrindo seus chamados...</title></head>' +
        '<body style="margin:0;display:flex;align-items:center;justify-content:center;' +
        'height:100vh;font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;' +
        'color:#546e7a;background:#f8fafc">' +
        '<div style="text-align:center">' +
        '<div style="font-size:15px">Abrindo seus chamados...</div>' +
        '<div style="font-size:13px;color:#90a4ae;margin-top:6px">Aguarde um instante</div>' +
        '</div></body></html>',
    );
    aba.document.close();
  } catch {
    /* alguns navegadores recusam escrever na aba; ela só fica em branco */
  }
};

export const abrirPortalSuporte = async () => {
  // Conta em demonstração não tem portal de chamados: o atendimento dela é
  // pelo chat do comercial, e cadastrá-la no TomTicket encheria o painel de
  // organizações que expiram em uma semana.
  if (ehDemonstracao()) return false;

  // A aba precisa ser aberta dentro do gesto de clique; se esperarmos a
  // resposta para só então chamar window.open, o navegador bloqueia o pop-up.
  // Sem 'noopener' nas features de propósito: com ela o retorno é sempre null
  // e não haveria como navegar a aba depois. A referência de volta é cortada
  // na mão, abaixo, antes de atribuir a URL.
  const aba = window.open('', '_blank');

  // A aba nasce vazia e só recebe o endereço quando o backend responde. Sem
  // isto ela fica em branco por um ou dois segundos, o que parece travamento.
  avisarNaAba(aba);

  try {
    const res = await axios.post('/api/tickets/', { dest: 'acesso' });
    const url = res?.data?.url;

    if (url) {
      if (aba) {
        // Impede que o portal alcance esta janela por window.opener.
        try {
          aba.opener = null;
        } catch {
          /* alguns navegadores não deixam escrever; seguir mesmo assim */
        }
        aba.location.href = url;
      } else {
        // Pop-up bloqueado: entrega o link para o usuário abrir manualmente.
        await swal.fire({
          title: 'Libere a abertura de abas',
          html:
            'Seu navegador bloqueou a nova aba.<br/>' +
            `<a href="${url}" target="_blank" rel="noopener noreferrer">Clique aqui para acessar seus chamados</a>`,
          icon: 'info',
          confirmButtonText: 'Entendi',
        });
      }
      return true;
    }

    if (aba) aba.close();
    mostrarFalha(res?.data?.detail, res?.data?.error);
  } catch (err) {
    if (aba) aba.close();
    mostrarFalha(err?.detail || err?.details, err?.message || err?.code);
  }

  return false;
};

/**
 * Alerta de falha. O detalhe entra como linha secundária em vez de ser
 * descartado: sem ele a tela mostra sempre a mesma mensagem genérica do
 * interceptor do axios, que não diz o que de fato aconteceu.
 */
const mostrarFalha = (detalhe, causa) => {
  const extra = [detalhe, causa].filter(Boolean).join(' — ');

  swal.fire({
    title: 'Não foi possível acessar',
    html:
      'Tente novamente em instantes.' +
      (extra ? `<br/><small style="color:#90a4ae">${String(extra).slice(0, 300)}</small>` : ''),
    icon: 'error',
    confirmButtonText: 'Fechar',
  });
};

export default abrirPortalSuporte;
